import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAbsoluteCenter, m} from "@pg-design/helpers-css";
import {useUserDevice} from "@pg-mono/user-device";

import {NavButton} from "../../../atoms/NavButton";
import {getPropertyPlanModalTitle} from "../../utils/get_property_plan_modal_title";

interface IProps {
    property: {
        area: number;
        offer: {
            address: string;
            type: number;
        };
        rooms: number;
    } | null;
    statsLabel: string;
    onNextClick: () => void;
    onPrevClick: () => void;
}

export const PropertyPlanModalHeader = (props: IProps) => {
    const {property, statsLabel, onNextClick, onPrevClick} = props;
    const {isMobile} = useUserDevice();

    const title = property && getPropertyPlanModalTitle(property);

    return (
        <div css={propertyPlanModalHeader}>
            {!isMobile && <span css={titleStyle}>{title}</span>}

            <div css={navWrap}>
                <div css={flexAbsoluteCenter}>
                    <NavButton onClick={onPrevClick} direction="prev">
                        <div css={buttonsText}>
                            <span css={m(0, 1, 0, 0)}>Poprzednie</span>
                        </div>
                    </NavButton>

                    <NavButton onClick={onNextClick} direction="next">
                        <div css={buttonsText}>
                            <span css={m(0, 1, 0, 0)}>Następne</span>
                        </div>
                    </NavButton>
                </div>
                <div css={flexAbsoluteCenter}>
                    <span css={statsLabelStyle}>{statsLabel}</span>
                </div>
            </div>
        </div>
    );
};

const propertyPlanModalHeader = (theme: Theme) => css`
    display: flex;
    justify-content: space-between;
    padding: 2.6rem 4.6rem;

    @media (max-width: ${theme.breakpoints.md}) {
        justify-content: center;
    }
`;

const titleStyle = css`
    font-weight: 500;
    font-size: 2.2rem;
    line-height: 3.08rem;
    color: #fff;
`;

const statsLabelStyle = (theme: Theme) => css`
    color: #fff;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.8rem;
    margin: 0 1.7rem;

    @media (max-width: ${theme.breakpoints.md}) {
        font-size: 1.8rem;
        font-weight: 500;
        line-height: 2.52rem;
    }
`;

const buttonsText = (props: Theme) => css`
    display: none;

    @media (min-width: ${props.breakpoints.md}) {
        display: block;
    }
`;

const navWrap = css`
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAbsoluteCenter, m} from "@pg-design/helpers-css";
import {useUserDevice} from "@pg-mono/user-device";

import {NavButton} from "../../../atoms/NavButton";
import {getPropertyPlanModalTitle} from "../../utils/get_property_plan_modal_title";

interface IProps {
    property: {
        area: number;
        offer: {
            address: string;
            type: number;
        };
        rooms: number;
    } | null;
    statsLabel: string;
    onNextClick: () => void;
    onPrevClick: () => void;
}

export const PropertyPlanModalHeader = (props: IProps) => {
    const {property, statsLabel, onNextClick, onPrevClick} = props;
    const {isMobile} = useUserDevice();

    const title = property && getPropertyPlanModalTitle(property);

    return (
        <div css={propertyPlanModalHeader}>
            {!isMobile && <span css={titleStyle}>{title}</span>}

            <div css={navWrap}>
                <div css={flexAbsoluteCenter}>
                    <NavButton onClick={onPrevClick} direction="prev">
                        <div css={buttonsText}>
                            <span css={m(0, 1, 0, 0)}>Poprzednie</span>
                        </div>
                    </NavButton>

                    <NavButton onClick={onNextClick} direction="next">
                        <div css={buttonsText}>
                            <span css={m(0, 1, 0, 0)}>Następne</span>
                        </div>
                    </NavButton>
                </div>
                <div css={flexAbsoluteCenter}>
                    <span css={statsLabelStyle}>{statsLabel}</span>
                </div>
            </div>
        </div>
    );
};

const propertyPlanModalHeader = (theme: Theme) => css`
    display: flex;
    justify-content: space-between;
    padding: 2.6rem 4.6rem;

    @media (max-width: ${theme.breakpoints.md}) {
        justify-content: center;
    }
`;

const titleStyle = css`
    font-weight: 500;
    font-size: 2.2rem;
    line-height: 3.08rem;
    color: #fff;
`;

const statsLabelStyle = (theme: Theme) => css`
    color: #fff;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.8rem;
    margin: 0 1.7rem;

    @media (max-width: ${theme.breakpoints.md}) {
        font-size: 1.8rem;
        font-weight: 500;
        line-height: 2.52rem;
    }
`;

const buttonsText = (props: Theme) => css`
    display: none;

    @media (min-width: ${props.breakpoints.md}) {
        display: block;
    }
`;

const navWrap = css`
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
`;
